module.exports = __webpack_public_path__ + "img/75.13036261.jpg";